// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const { updateConsents } = require('actions/gdprConsents');
const {
    reset: resetTravelPlus,
    setTravelPlus,
} = require('actions/hireTravelPlus');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');

// @ constants
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_API, CARDS } = require('constants/index');
const { CARD_ACTIVATION_GREATER_THAN_ONE_YEAR } = require('constants/flagBasedFeatures');
const { getCardType, getCardData } = require('utilities/cardsHelper');
const {
    APLAZADO_TAE,
    APLAZADO_TIN,
} = require('constants/AFISimulator.js');

const resetWizard = () => ({
    type: actionTypes.SET_CARD_ACTIVATION_R42_RESET
});

const reset = () => dispatch => {
    dispatch(resetWizard());
    dispatch(resetTravelPlus());
};

const setTravelPlusState = travelPlusState => ({
    type: actionTypes.SET_CARD_ACTIVATION_R42_TRAVEL_PLUS_STATE,
    payload: {
        travelPlusState,
    }
});

const setVisibleStep = step => ({
    type: actionTypes.SET_CARD_ACTIVATION_R42_SET_VISIBLE_STEP,
    payload: {
        step,
    }
});

const validate = step => ({
    type: actionTypes.SET_CARD_ACTIVATION_R42_VALIDATE_STEP,
    payload: {
        step,
    }
});

const getStep = step => (dispatch, getState) => {
    const valid = getState().cardActivationR42.getIn(['steps', step - 1, 'valid']);
    if (!valid) {
        scrollToTop();
    }
    return valid;
};

const validateStep = (step) => (dispatch) => {
    dispatch(validate(step));
    return dispatch(getStep(step));
};

const setWillCancel = willCancel => ({
    type: actionTypes.SET_CARD_ACTIVATION_R42_WILL_CANCEL,
    payload: {
        willCancel,
    }
});

const activateR42CardRequest = () => ({
    type: actionTypes.SET_CARD_ACTIVATION_R42_REQUEST,
});

const activateR42CardSuccess = response => ({
    type: actionTypes.SET_CARD_ACTIVATION_R42_SUCCESS,
    payload: {
        response,
    }
});

const activateR42CardFailure = errorMsg => ({
    type: actionTypes.SET_CARD_ACTIVATION_R42_FAILURE,
    payload: {
        errorMsg,
    }
});

const toggleHireTravelPlus = () => ({
    type: actionTypes.SET_CARD_ACTIVATION_R42_HIRE_TRAVEL_PLUS_VALUE,
});

const setR42CardActivation = (dispatch, data, travelPlusActivated, cardId, dataToken, header = false) => {
    const requestData ={
        query: data,
        ...(header && {header: {version: __CONTACT_CENTER__ ? 2 : 4}})
    }

    dispatch(activateR42CardRequest());

    return APIPost({
        dispatch,
        endpoint: 'cardActivation',
        params: requestData,
    })
        .then(response => {
            if (travelPlusActivated) {
                dispatch(setTravelPlus(cardId, dataToken, null, true));
            }

            dispatch(activateR42CardSuccess(response));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(activateR42CardFailure(response.error));
            }
            else {
                throw response;
            }
        });
};

const activateCardR42 = (cardId, travelPlusActivated)  => (dispatch, getState) => {
    const callback = (dispatchSignature, getStateSignature, dataToken) => {
        const immCard = getStateSignature().cards.getIn(['byId', cardId]);
        const isCreditCard = immCard.get('type') === CARDS['CREDIT'] && getState().flagBasedFeatures.get(CARD_ACTIVATION_GREATER_THAN_ONE_YEAR)
        const immGlobalVariables = getState().globalVariables
        const cardType = getCardType(immCard);
        const tin = getCardData(cardType, APLAZADO_TIN, immGlobalVariables);
        const tae = getCardData(cardType, APLAZADO_TAE, immGlobalVariables);

        const data = {
            dataToken,
            contratoTarjeta: {
                numerodecontrato: immCard.getIn(['contract', 'number']),
                producto: immCard.getIn(['contract', 'product']),
            },
            fechaCaducidad: immCard.get('expirationDate').format(DATE_FORMAT_API),
            numeroContrato: immCard.getIn(['contract', 'number']),
            numeroTarjeta: immCard.get('number'),
            producto: immCard.getIn(['contract', 'product']),
            ...(isCreditCard && {
                standard: immCard.getIn(['criteria', 'c1', 'estand']),
                subProductType: immCard.getIn(['criteria', 'c1', 'subtipoproducto']),
                amount: immCard.getIn(['limit', 'amount']),
                tae: Number(tae.replace(/%/g, '').replace(',', '.')),
                interestRate : Number(tin.replace(/%/g, '').replace(',', '.')) / 100
            })
        };

        dispatchSignature(updateConsents(dataToken))
            .then(() => setR42CardActivation(dispatchSignature, data, travelPlusActivated, cardId, dataToken, isCreditCard))
            .catch(response => {
                if (!!response.error) {
                    setR42CardActivation(dispatchSignature, data, travelPlusActivated, cardId, dataToken, isCreditCard);
                } else {
                    throw response;
                }
            });

    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
};

module.exports = {
    activateCardR42,
    reset,
    setTravelPlusState,
    setVisibleStep,
    setWillCancel,
    toggleHireTravelPlus,
    validateStep,
};
